"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionTreeNodeExpander = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const CollapseArrowIcon_1 = __importDefault(require("@opsbase/web-icons/icons/CollapseArrowIcon"));
const ExpandArrowIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ExpandArrowIcon"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const react_1 = __importStar(require("react"));
const useFedActions_1 = __importDefault(require("../FedController/useFedActions"));
const useFedExpand_1 = __importDefault(require("../FedController/useFedExpand"));
const makeMyClasses = () => ({
    button: {
        position: 'absolute',
        left: 8,
        top: 14,
        zIndex: 10,
    },
});
exports.QuestionTreeNodeExpander = react_1.default.memo((props) => {
    const { question } = props;
    const { expands } = (0, useFedExpand_1.default)();
    const { doExpand } = (0, useFedActions_1.default)();
    const isExpanded = !!expands[question.qId];
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const handleClick = (0, react_1.useCallback)(() => {
        doExpand(question.qId);
    }, [doExpand, question]);
    return (0, react_1.useMemo)(() => {
        var _a;
        const canHaveChildren = !!((_a = question.childListIds) === null || _a === void 0 ? void 0 : _a.length);
        const hasName = !!question.title;
        if (!canHaveChildren || !hasName)
            return null;
        const icon = isExpanded ? react_1.default.createElement(ExpandArrowIcon_1.default, { size: 20 }) : react_1.default.createElement(CollapseArrowIcon_1.default, { size: 20 });
        return (react_1.default.createElement(Button_1.default, { classes: { root: myCss.button + ' hideInGhost hideInDrag' }, round: true, tiny: true, color: lib_palette_1.default.Black, onClick: handleClick, icon: icon }));
    }, [question, isExpanded, myCss, handleClick]);
});
exports.default = exports.QuestionTreeNodeExpander;
